import "./ProgressBar.css";

import { OrganisationTypeConstants } from "../../../../../../constants";

interface ProgressBarProps {
  completed: number;
  inReview: number;
  inProgress: number;
  blocked: number;
  todo: number;
  unassigned: number;
  currentUserType: OrganisationTypeConstants;
}

export const ProgressBar = ({
  completed,
  inReview,
  inProgress,
  blocked,
  todo,
  unassigned,
  currentUserType,
}: ProgressBarProps): JSX.Element => {
  return (
    <div className={`ProgressBarGraph ${currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "Rounded" : ""}`}>
      {completed > 0 && <div className="BarSegment completed" style={{ flex: completed }} />}
      {inReview > 0 && <div className="BarSegment inReview" style={{ flex: inReview }} />}
      {inProgress > 0 && <div className="BarSegment inProgress" style={{ flex: inProgress }} />}
      {blocked > 0 && <div className="BarSegment blocked" style={{ flex: blocked }} />}
      {todo > 0 && <div className="BarSegment todo" style={{ flex: todo }} />}
      {unassigned > 0 && <div className="BarSegment unassigned" style={{ flex: unassigned }} />}
    </div>
  );
};
